module.exports = __webpack_public_path__ + "img/verify_status_failed.6d341fba.svg";